import {Component, ElementRef, ViewChild} from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { getLocalJSON } from '../../_helpers/storage.util';

@Component({
  selector: 'app-collebration-detail',
  templateUrl: './collebration-detail.component.html',
  styleUrls: ['./collebration-detail.component.scss']
})
export class CollebrationDetailComponent {

  
  public albumListing:any=[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public filter3:boolean= false;
  public filter1:boolean= true;
  public filter2:boolean = false;
  public tabType:any='';
  public filterType:any='';
  public filterTypeValue:any='';
  public filterCTypeValue:any='';
  public filtersTypeValue:any='';
  public loading:boolean = false;
  public previousLabel:any='';
  public nextLabel:any='';
  public loginDetail:any =[];
  public cookingList:any=[];
  public dietList:any=[];
  public primaryList:any=[];
  public OrgList:any=[];
  public Views:boolean=false;


  constructor(public router: Router, public service: GlobalService) {
    this.loginDetail = getLocalJSON('grw_login'); 
    this.getData(1);
   }

   ngOnInit(): void {
     }

  getData(page:any){
    this.loading= true;    
    var url="/collaborators-details";
    var detail:any={
      "page": page,   
      "req_id": localStorage.getItem('grw_ids')
    };
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success ==1) { 
        var ss:any=[];
        response.data.record.filter((el:any)=>{
          el.posts.filter((ell:any)=>{
            ss.push(ell);
          })        
        }) 
        this.albumListing= ss;
        this.totalCount = response.data.total;
        this.loading=false;
      } else {
        this.albumListing=[];
        this.loading=false;
      }
      
    }), (error) => { this.loading =false; });
  }

  redirect(data:any){
    localStorage.setItem('grw_content_id',data._id);   
      this.router.navigate(['/video-detail']);
  }
}
